import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import DashboardMenu from "./DashboardMenu";
import CircularProgress from "@mui/material/CircularProgress";
import Order from "./Order";
import HelpDrawer from "./HelpDrawer";

import { db, collection, getDocs, query, orderBy, limit } from "../../firebase";

const useStyles = makeStyles({
	root: { width: 1, display: "flex", paddingBottom: "100px" },
	body: {
		width: "100%",
		borderRadius: "5px",
		border: "1px solid lightgray",
		marginBottom: "30px",
	},
	inputEach: {
		display: "flex",
		alignItems: "center",
		paddingLeft: "10px",
		paddingRight: "10px",
		marginBottom: "20px",
		marginTop: "20px",
	},
	inputs: { width: "70%" },
	label: { width: "160px" },
});

const OrderHistory = () => {
	const classes = useStyles();
	let navigate = useNavigate();
	const { currentUser, getFirstname, getLastname } = useAuth();
	const [phone, setPhone] = useState("");
	const [firstname, setFirstname] = useState("");
	const [lastname, setLastname] = useState("");
	const [progress, setProgress] = useState(true);

	const [orders, setOrders] = useState([]);

	useEffect(() => {
		setFirstname(getFirstname());
		setLastname(getLastname());
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setProgress(false);
		}, 500);
	}, []);

	useEffect(() => {
		const getOrders = async () => {
			const userRef = collection(db, "users", currentUser.uid, "orders");

			const q = query(userRef, orderBy("created"), limit(10));

			let orders = [];
			await getDocs(q).then((snapshot) => {
				snapshot.docs.forEach((doc) => {
					orders.push({ id: doc.id, ...doc.data() });
				});
			});
			console.log(orders);
			setOrders(orders);
		};
		if (currentUser) {
			getOrders();
		} else {
			setOrders([]);
		}
		console.log(orders);
	}, []);

	return (
		<Grid className={classes.root} container sx={{ px: 10 }}>
			<Grid
				item
				sm={12}
				md={4}
				sx={{
					// border: "1px solid black",
					px: { md: 3 },
					py: { md: 5, sm: 4 },
				}}
			>
				<DashboardMenu page="order-history" />
			</Grid>
			<Grid
				sm={12}
				md={8}
				item
				sx={{
					// border: "1px solid black",
					px: { md: 3 },
					py: { md: 5, sm: 2 },
				}}
			>
				<Box className={classes.body}>
					<Box
						sx={{
							width: "100%",
							py: 2,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							overflow: "hidden",
						}}
					>
						<Box
							sx={{
								width: "100%",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								boxSizing: "border-box",
								px: 4,
							}}
						>
							<Box sx={{ width: 1 }}>
								<Box
									sx={{
										pt: 1,
										fontSize: "23px",
										display: "flex",
										justifyContent: "space-between",
									}}
								>
									<Box>Your orders</Box>
									<Box
										sx={{
											fontSize: "12px",
											border: "1px solid gray",
											padding: "6px",
											borderRadius: "4px",
											cursor: "pointer",
										}}
									>
										<HelpDrawer />
									</Box>
								</Box>
							</Box>

							<Box
								sx={{
									display: "flex",
									justifyContent: progress ? "center" : "flex-start",
									alignItems: "flex-start",
									width: "100%",
									minHeight: "400px",
									boxSizing: "border-box",
									pt: progress ? 5 : 0,
								}}
							>
								{progress ? (
									<CircularProgress />
								) : (
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											pt: 2,
										}}
									>
										<Box>
											{orders?.map((order) => (
												<Order order={order} />
											))}
										</Box>
									</Box>
								)}
							</Box>
						</Box>
					</Box>
				</Box>
			</Grid>
		</Grid>
	);
};

export default OrderHistory;
